import React from 'react';
import SvgIcon from '../../images/ilustrations/Anye_candado_new.svg';

const AnyeCandado = () => (
    <img src={SvgIcon} alt="Candado" style={{ width: '1.5em', height: '1.5em' }} />
);

export default AnyeCandado;
